{
  "common": {
    "viewAll": "View All",
    "search": "Search",
    "searchPlaceholder": "Search Here"
  },
  "header": {
    "myProfile": "My Profile",
    "accountSettings": "Account Settings",
    "needHelp": "Need Help ?",
    "signOut": "Sign Out"
  },
  "sidebar": {
    "adsAnalysis": "Ad Insights",
    "regionalWiseSales":"Regional Wise Sales",
    "actionableCondition": "Seller Radar",
    "dashboardHome" : "Dashboard" ,
    "regionalLevelSales" : "Area Wise Insights",
    "geographicalSalesInsights" : "Geo Insights",
    "timeSalesAnalysis" : "TimeLens",
    "productGrowth" : "Product Growth",
    "products" : "Products",
    "Settings" : "Settings",
    "interactiveSalesMap" : "Map Integration",
    "stateWiseSales" : "State Wise Sales",
    "city" : "City",
    "pinCode" : "Pin Code",
    "order" : "Orders",
    "reportProcessing" : "Report Processing",
    "marketPlaceAccounts" : "Marketplace Accounts",
    "reviewRating" : "Review & Rating",
    "discussionBox" : "Suggestion Portal",
    "referal":"Referral",
    "supportTicket":"Support Tickets",
    "billingSection":"Billing Section",
    "rateUs": "Rate Us"
  },
  "login": {
    "title": "Sign In",
    "subtitle": "We suggest the email address you use at work.",
    "signInTab": "Sign In",
    "signUpTab": "Sign Up",
    "emailLabel": "Email*",
    "emailPlaceholder": "Enter your email address",
    "passwordLabel": "Password*",
    "passwordPlaceholder": "Enter your password",
    "forgotPassword": "Forgot Password?",
    "submit": "Sign In",
    "submitting": "Submitting...",
    "name": "Full name",
    "namePlaceholder": "Enter your full name",
    "subject": "Issue *",
    "subjectPlaceholder": "Enter your subject",
    "message": "Message*",
    "messagePlaceholder": "Enter the message",
    "support":"Submit Ticket",
    "supportTitle":" Need help? Report an issue",
    "file":"Attached Screenshot",
    "contactUs":"Contact Us"
  },
  "forgotPassword": {
    "title": "Forgot Password",
    "subtitle": "No worries, we'll send you instructions to reset your password.",
    "emailLabel": "Email*",
    "emailPlaceholder": "Enter your email address",
    "resetButton": "Reset Password",
    "submitting": "Submitting...",
    "backToSignIn": "Back to sign in"
  },
  "otpVerification": {
    "errorIncomplete": "Please enter all 6 digits",
    "verifying": "Verifying...",
    "verify": "Verify",
    "notReceived": "Didn’t get it?",
    "resend": "Click here to Resend.",
    "backToSignUp": "Back To Sign Up"
  },
  "register": {
    "setupAccount": "Setup Your Account",
    "personalizeExperience": "Let's personalize your experience to suit your business needs.",
    "signUp": "Sign Up",
    "firstName": "First Name*",
    "firstNamePlaceholder": "Enter your first name",
    "lastName": "Last Name*",
    "lastNamePlaceholder": "Enter your last name",
    "email": "Email*",
    "emailPlaceholder": "Enter your email address",
    "phoneNumber": "Phone Number*",
    "phonePlaceholder": "Enter your phone number",
    "next": "Next",
    "brandName": "Brand Name",
    "brandNamePlaceholder": "Enter your brand name",
    "sector": "Category*",
    "password": "Password*",
    "passwordPlaceholder": "Enter your password",
    "confirmPassword": "Confirm Password*",
    "confirmPasswordPlaceholder": "Enter your confirm password",
    "back": "Back",
    "submitting": "Submitting...",
    "selectSector": "Select Category",
    "fullName": "Name*",
    "fullNamePlaceholder": "Enter your full name",
    "referalCode": "Referal Code",
    "referalCodePlaceholder": "Enter Referal Code"
  },
  "countries": {
    "us": "United States",
    "ca": "Canada",
    "in": "India"
  },
  "resetPassword": {
    "title": "Forgot Password",
    "subtitle": "New password must be different from your previous used passwords.",
    "password": "Password*",
    "passwordPlaceholder": "Enter your password",
    "confirmPassword": "Confirm Password*",
    "confirmPasswordPlaceholder": "Enter your confirm password",
    "submit": "Reset Password",
    "submitting": "Resetting..."
  },
  "billingAddress":{
   "address_1":"Building/Flat No.*",
   "address_2":"Street/Area*",
   "state":"State*",
   "city":"City*",
   "pincode":"Pincode*",
   "country":"Country*",
   "addressPlaceholder":"Enter your building or flat number",
   "addressOtherPlaceholder":"Enter your street name or area",
   "statePlaceholder":"Enter your state",
   "cityPlaceholder":"Enter your city",
   "pincodePlaceholder":"Enter your pincode",
   "countryPlaceholder":"Enter your country"
  },
  "thankYou": {
    "title": "Thank You for Signing Up with AWS",
    "subtitle": "You can start using the tool right away.",
    "button": "Continue"
  },
  "adsAnalysis": {
    "title": "Category Performace Dashboard"
  },
  "dashboardHome": {
    "totalRevenue": "Total Revenue",
    "kpiCategories":"KPI Categories",
    "salesVsSpendAnalysis": "Sales Vs Spend Analysis",
    "report": "Report",
    "today": "Today",
    "bussinessRevenue": "Bussiness Revenue",
    "bussinessGross": "Bussiness Growth Unit",
    "salesByState": "Sales By State",
    "topSellingProducts": "Top Selling Products",
    "topSellingCategory": "Top Selling Categories",
    "paymentMode": "Payment Distribution"
  },
  "geographicalSalesInsights": {
    "fullfillmentChannel": "Fullfillment Channel",
    "regionalShare": "Regional Share",
    "eliteWarehouse": "Elite Warehouse",
    "geographicalSales": "Geographical Sales"
  },
  "timeSalesAnalysis": {
    "timeBasedSalesAnalysis": "Time Based Sales Analysis",
    "weeklySalesDistribution": "Weekly Sales Distribution",
    "timeSalesAnalysis": "Time Sales Analysis"
  },
  "productGrowth": {
    "monthlyTrends&CategoryShare": "Monthly Trends & Category Share",
    "productGrowth": "Product Growth"
  },
  "regionalLevelSales": {
    "region": "Region",
    "state": "State",
    "city": "City",
    "postal": "Pincode",
    "regionWiseSales": "Regional Wise Sales Table",
    "regionWiseSalesGraph":"Regional Wise Sales Graph",
    "stateWiseSales": "State Wise Sales",
    "cityWiseSales": "City Wise Sales",
    "pincodeWiseSales": "Pincode Wise Sales",
    "regionalWiseUnitConsumption": "Regional Wise Unit Consumption",
    "costDistribution": "Cost Distribution"
  },
  "checkboxSelect": {
    "heading": "See the selected record reflection on graph",
    "refreshPage": "Refresh Page"
  },
  "staticPages": {
    "priceSection": {
      "couponCode": "Coupon code",
      "apply":"Apply"
    }
  },
  "marketplace":{
    "addAccount":"Add Account"
  },
  "pendingPlanSection":{
    "heading":"Complete Your Pending Payment",
    "processingHeading":"Processing your pending payment...",
    "subHeading":"You’re almost there! Finish your payment to activate your subscription.",
    "billed":"Billed",
    "pending":"Pending",
    "active":"Active",
    "payment":"Payment",
    "Processing":"Processing...",
    "ContinuePayment":"Continue to Payment",
    "additionaly1":"Safe and secure payment powered by Razorpay.",
    "additionaly2":"You can retry payment anytime if it failed previously."
  }
}